'use es6';

import invariant from '../../lib/invariant';
export const getConfigId = (state, config) => state.resolve.getIn(['configs', config], null);
export const getDataPromise = (state, config) => {
  const id = getConfigId(state, config);
  invariant(id != null, 'Cannot retrieve data promise of config not in store');
  return state.resolve.getIn(['resolving', id, 'promise']);
};